import { Validators } from '@angular/forms';
import { CodesRessourcesModel, ConfigurationRessourceModel } from '../models/ressources.model';

/**
 * Service qui donne les propriétés des ressources en fonction du profil de la personne (enfants exclus)
 */
export class RessourcesPropertiesService {

  /**
   * Constructeur
   */
  constructor() {}

  /**
   * Pattern pour la validation des montant (entiers > 0)
   */
  public static PATTERN_NUMERIQUE_ENTIER_POSITIF = "^([1-9][0-9]*)$";

  /**
   * Pattern pour la validation des montant (entiers)
   */
  public static PATTERN_NUMERIQUE_ENTIER = "^[-]?([1-9][0-9]*)$";

  /**
   * donne l'année moins 2
   */
  private static restituerAnneeMoins2(date : Date) : number {
    return date.getFullYear() - 2;
  }

  /**
   * Génération d'un code avec le profil personne
   * @param code string
   * @param profil  number
   */
  private static genererCodeAvecProfil(code : string, profil : number) : string {
    return code.concat(String(profil));
  }

  /**
   * Generation de l'objet contenant les codes associées aux ressources à demander au niveau demandeur / conjoint
   * @param profil 
   */
  static genererCodesRessources(profil : number) : CodesRessourcesModel {
    const codesRess = new CodesRessourcesModel();
    codesRess.aucuneRessource = RessourcesPropertiesService.genererCodeAvecProfil("AUCUN_REVENU_", profil);
    codesRess.salaire = RessourcesPropertiesService.genererCodeAvecProfil('SALAIRE_', profil);
    codesRess.allocationChomage = RessourcesPropertiesService.genererCodeAvecProfil('ALLOCATION_CHOMAGE_', profil);
    codesRess.pensionAlimentaireRecue = RessourcesPropertiesService.genererCodeAvecProfil('PENSION_ALIMENTAIRE_RECUE_', profil);
    codesRess.retraitrePensionImposable = RessourcesPropertiesService.genererCodeAvecProfil('RETRAITE_PENSION_IMPOSABLE_', profil);
    codesRess.revenuTravailleurIndependant = RessourcesPropertiesService.genererCodeAvecProfil('REVENU_TRAVAILLEUR_INDEPENDANT_', profil);
    return codesRess;
  }

  /**
   * Donne la liste des messages à afficher dans les montants des rubriques en cas d'erreur
   */
  static getMapMessagesErreurMontants() : Map<string, string> {
    const mapErreurs = new Map<string, string>();
    mapErreurs.set("required", "Champ obligatoire");
    mapErreurs.set("pattern", "Ce montant doit être un nombre entier");
    return mapErreurs;
  }

  /**
   * Donne les propriétés associées aux ressources
   * 
   * @param date  Date
   * @param profil string
   */
  static getRessourcesProperties(date : Date, profil : number) : Array<ConfigurationRessourceModel> {

    const codesRessources = RessourcesPropertiesService.genererCodesRessources(profil);

    return [
      {
        code: codesRessources.salaire,
        libelle: 'Salaires',
        validators: [Validators.required, Validators.pattern(this.PATTERN_NUMERIQUE_ENTIER_POSITIF)],
        placeHolder: '0'
      },
      {
        code: codesRessources.allocationChomage,
        libelle: 'Allocations de chômage et préretraite',
        validators: [Validators.required, Validators.pattern(RessourcesPropertiesService.PATTERN_NUMERIQUE_ENTIER_POSITIF)],
        placeHolder: '0'
      },
      {
        code: codesRessources.retraitrePensionImposable,
        libelle: 'Retraites et pensions',
        validators: [Validators.required, Validators.pattern(RessourcesPropertiesService.PATTERN_NUMERIQUE_ENTIER_POSITIF)],
        placeHolder: '0'
      },
      {
        code: codesRessources.pensionAlimentaireRecue,
        libelle: 'Pension alimentaire reçue',
        validators: [Validators.required, Validators.pattern(RessourcesPropertiesService.PATTERN_NUMERIQUE_ENTIER_POSITIF)],
        placeHolder: '0'
      },
      {
        code: codesRessources.revenuTravailleurIndependant,
        libelle: 'Revenu ou déficit de travailleur indépendant de l’année '.concat(String(this.restituerAnneeMoins2(date))),
        validators: [Validators.required, Validators.pattern(RessourcesPropertiesService.PATTERN_NUMERIQUE_ENTIER)],
        placeHolder: 'Ex : -500, 250'
      }
    ];
  }

}
